import { string } from 'prop-types';

export const FILTER_CAROUSEL_TILE = {
    slug: string,
    image: string,
    title: string,
};
